<template>
  <div id="app" style>
    <div class>
      <!---->
      <Header-el></Header-el>
      <div class="detail-contents">
        <div
          class="public-detail-window"
          :style="'background-image: url(&quot;'+project.ImageUrl+'&quot;);'"
        >
          <div class="content-box">
            <div class="public-video-small">
              <!-- <img src="http://images.kaishiba.com/default-video-poster.png?imageView2/2/w/320"> -->
              <video :src="project.VideoUrl" v-if="project.VideoUrl!=undefined"/>
              <a href="javascript:;">
                <span class="icon-kaistart-trigon"></span>
              </a>
            </div>
            <div>
              <h3>{{project.Title}}</h3>
              <!-- <p v-html="project.Quote"></p> -->
              <a href="/user/index/id/52494344059CE116E050190AFD013A23">
                <img src="http://images.kaistart.com/header2.png">
              </a>
              <a href="/user/index/id/52494344059CE116E050190AFD013A23">{{project.Promoter}}</a>
              <span>
                {{project.StartTime}}
                {{project.Address}}
              </span>
            </div>
          </div>
          <ul class="public-time-left">
            <li>
              <p>{{global.surplus.day}}</p>
              <span>天</span>
            </li>
            <li>
              <p>{{global.surplus.hours}}</p>
              <span>小时</span>
            </li>
            <li>
              <p>{{global.surplus.minute}}</p>
              <span>分</span>
            </li>
            <li>
              <p>{{global.surplus.second}}</p>
              <span>秒</span>
            </li>
          </ul>
          <ul class="public-comment-like-share">
            <li>
              <a href="/special/sys/down" target="_blank">
                <span class="icon-kaistart-comment"></span>0
              </a>
            </li>
            <!---->
          </ul>
        </div>
        <div id="detail-content" class="detail-content clearfix">
          <div id="detail-content-left" class="detail-content-left">
            <!---->
            <div class="detail-my-readme">
              <div>
                <div id="quote">
                  <!---->
                  <div v-html="project.Quote"></div>
                  <div class="public-devider-line">
                    <p></p>
                  </div>
                </div>
                <div id="about">
                  <div v-html="project.About"></div>
                  <div class="public-devider-line">
                    <p></p>
                  </div>
                </div>
                <div id="myProject">
                  <div v-html="project.MyProject"></div>
                  <div class="public-devider-line">
                    <p></p>
                  </div>
                </div>
                <div id="why">
                  <div class="public-detail-title public-detail-title-no-p">
                    <h5>为何发起</h5>
                    <!---->
                  </div>
                  <div v-html="project.Why"></div>
                  <div class="public-devider-line">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
            <div id="business-info" class="business-info">
              <div id="addressInfo1517902272935" class="section">
                <div class="public-detail-title">
                  <span>项目地址</span>
                </div>
                <div class="address bg-white">
                  <!---->
                  <p>
                    <img src="data:image/png;base64,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" alt style="width: 10px; margin-right: 8px;">
                    {{project.Address}}
                  </p>
                </div>
                <div class="public-devider-line">
                  <p></p>
                </div>
              </div>
              <div id="baseInfo1517902272935" class="section">
                <div class="public-detail-title">
                  <span>项目基本信息</span>
                </div>
                <div class="base-info bg-white">
                  <div class="border-box">
                    <p class="title-name">项目名称</p>
                    <ul>
                      <li class="title-desc">{{project.Name}}</li>
                    </ul>
                  </div>
                  <!---->
                  <!---->
                  <div class="border-box">
                    <p class="title-name">项目特色</p>
                    <ul>
                      <li class="title-desc text-justify">
                        <p v-html="project.Feature"></p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="public-devider-line">
                  <p></p>
                </div>
              </div>
              <!---->
              <div id="memberInfo1517902272935" class="section">
                <div class="public-detail-title">
                  <span>我的团队</span>
                </div>
                <div
                  class="border-box members-box bg-white flex-display"
                  v-for="(team,index) in showTeamList"
                  v-bind:key="index"
                >
                  <div class="left">
                    <img :src="'http://192.168.4.139:33564'+team.Photo" alt>
                    <p class="name">{{team.Name}}</p>
                    <p class="role">{{team.Role}}</p>
                  </div>
                  <p class="background" v-html="team.Profile"></p>
                </div>
                <div
                  class="flex-display showMore"
                  style="justify-content: center;"
                  @click="global.isshowteamall=!global.isshowteamall"
                >
                  <span>{{showTeamWord}}</span>
                  <img
                    alt
                    :src="'http://images.kaishiba.com/arrow-circle-'+(global.isshowteamall?'up':'down')+'.png'"
                  >
                </div>
                <div class="public-devider-line">
                  <p></p>
                </div>
              </div>
              <!---->
              <div id="timeInfo1517902272935" class="section">
                <div class="public-detail-title">
                  <span>时间轴</span>
                </div>
                <div class="vux-timeline bg-white">
                  <ul>
                    <li
                      class="vux-timeline-item"
                      v-for="(timeline,index) in project.Timelines"
                      v-bind:key="index"
                    >
                      <div
                        :class="'vux-timeline-item-color vux-timeline-item-head'+((index==0||index==project.Timelines.length)?'-first':'')"
                        style="background-color: rgb(225, 225, 225);"
                      >
                        <i
                          class="vux-timeline-item-checked weui-icon weui_icon_success_no_circle weui-icon-success-no-circle"
                        ></i>
                      </div>
                      <div
                        class="vux-timeline-item-tail"
                        style="display: block; background-color: rgb(225, 225, 225);"
                      ></div>
                      <div class="vux-timeline-item-content">
                        <h4 class="recent">{{timeline.Date}}</h4>
                        <p class="recent text-justify" v-html="timeline.Summary"></p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="public-devider-line">
                  <p></p>
                </div>
              </div>
            </div>
            <p class="special-tip">
              *
              本项目涉及所有宣传资料及图片等均由项目方或发起人提供，平台仅做对外展示，如您对上述宣传资料及图片有疑问，欢迎在社区留言或联系项目方回复。
            </p>
          </div>
          <div class="detail-content-right">
            <div class="public-data-board">
              <span>{{sumProfits.SupportMoney}}</span>
              <span>元</span>
              <span
                style="display: inline-block; border: 1px solid rgb(255, 255, 255); color: rgb(255, 255, 255); line-height: 1; padding: 0px 2px; margin-left: 5px;"
              >?</span>
              <br>
              <span title="认筹人数*所支持档位全款（包含退款中金额）">认筹总金额</span>
              <div></div>
              <ul class="clearfix">
                <li>
                  <span>{{sumProfits.SupportUser}}</span>
                  <span>人</span>
                  <br>
                  <span title="指对项目存有认购意向且支付过预约金的用户总人次（包含退款人次记录）">认筹人数</span>
                </li>
                <li>
                  <span>{{project.Progress}}</span>
                  <span>%</span>
                  <br>
                  <span title="认筹金额/目标金额">认筹进度</span>
                </li>
              </ul>
              <p>目标金额：{{project.Valuation}} 元</p>
              <!---->
              <div>风险提示</div>
            </div>
            <div class="mb40" v-for="profits in project.Profits" v-bind:key="profits.ID">
              <div class="public-project-support">
                <div class="header">
                  <h3>{{getProfit(profits.ID).Money}}</h3>
                  <span>元</span>
                  <span>预约金</span>
                  <!---->
                  <p></p>
                </div>
                <div class="detail">
                  <!---->
                  <div class="title" v-html="profits.Content"></div>
                  <div class="delivery">
                    <p>
                      <span>配送说明：</span>
                      <span class="c666">无</span>
                    </p>
                  </div>
                  <div class="content">
                    <ul>
                      <li>剩余名额</li>
                      <li>发送回报时间</li>
                    </ul>
                    <ul>
                      <li>
                        <span class="orderpaying" style="display: none;">0笔订单正在支付</span> 无限制
                      </li>
                      <li>项目结束 10 天后发送</li>
                    </ul>
                  </div>
                  <!---->
                  <div class="bt">
                    <span>已有 {{getProfit(profits.ID).SupportUser}} 人支持</span>
                    <a href="/special/sys/down" target="_blank" class="btgreen btn22 qrwrap">
                      我要支持
                      <div class="showqr">
                        <p>扫码下载开始吧App</p>
                        <img src="https://static.kaishiba.com/qrcodeDownapp.png" alt="下载app支持">
                      </div>
                    </a>
                  </div>
                  <div class="reserveItem" style="display: none;">
                    <a href="javascript:;">有名额通知我</a>
                    <div class="reserve-mask" style="display: none;">
                      <p>我们会记录您的预约信息，该档位有空余名额时，我们会第一时间通知到您的手机 156xxxx0213</p>
                      <a href="javascript:;" class="btgreen" style="display: none;">预约提醒我</a>
                      <a href="javascript:;" class="btgreen" style="display: none;">已成功预约</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="detail-nav" class="detail-nav" style="position: absolute; left: 0px; top: 0px;">
            <ul class="public-detail-nav">
              <li>
                <a href="#about">
                  <span title="我的自述" class="normal icon-kaistart-about"></span>
                </a>
              </li>
              <li>
                <a href="#myProject">
                  <span title="我的项目" class="normal icon-kaistart-myProject"></span>
                </a>
              </li>
              <li>
                <a href="#why">
                  <span title="为何发起" class="normal icon-kaistart-why"></span>
                </a>
              </li>
              <li>
                <a href="#addressInfo1517902272935">
                  <span title="项目地址" class="normal icon-kaistart-about1"></span>
                </a>
              </li>
              <li>
                <a href="#baseInfo1517902272935">
                  <span title="项目基本信息" class="normal icon-kaistart-about2"></span>
                </a>
              </li>
              <li>
                <a href="#memberInfo1517902272935">
                  <span title="我的团队" class="normal icon-kaistart-about3"></span>
                </a>
              </li>
              <li>
                <a href="#timeInfo1517902272935">
                  <span title="时间轴" class="normal icon-kaistart-about4"></span>
                </a>
              </li>
            </ul>
          </div>
          <!---->
        </div>
      </div>
      <!---->
      <!---->
      <footer id="detail-footer" class="public-detail-footer">
        <div nov-for="(item, idx) in projectList" no:key="item.id">
          <a href="/project/detail/id/8532CEAE0F1D667CE05010ACD005229A">
            <img
              src="http://images.kaishiba.com/o_1ddmpkho51iqt5mn2ek19fshf219.jpg?imageView2/5/w/200"
            >
            <div>
              <p class="icon-kaistart-arrows-left"></p>
              <p>魔都闹市区里的小泰国，黄圣依私藏的SPA馆</p>
              <p>
                <span class="name">苏文星</span>
                <span class="time">2019年06月19日 上海市</span>
              </p>
            </div>
          </a>
        </div>
        <div nov-for="(item, idx) in projectList" no:key="item.id">
          <a href="/project/detail/id/89D55B5BC3C851D4E05010ACD0056395">
            <img
              src="http://images.kaishiba.com/o_1ddkhms2t1tbtqae1ebpvml159h14.jpg?imageView2/5/w/200"
            >
            <div>
              <p class="icon-kaistart-arrows-right"></p>
              <p>在北疆仙境，大西洋流下最后一滴泪，藏着「全世界的风景」</p>
              <p>
                <span class="name">郭文峰</span>
                <span class="time">2019年06月17日 博尔塔拉蒙古自治州</span>
              </p>
            </div>
          </a>
        </div>
      </footer>
      <navshare-el/>
      <!---->
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Header from "../components/header";
import Footer from "../components/footer";
import NavShare from "../components/navShare";
export default {
  name: "app",
  data() {
    return {
      global: {
        isshowteamall: false,
        surplus: { day: 0, hours: 0, minute: 0, second: 0 }
      }
    };
  },
  components: {
    "Header-el": Header,
    "footer-el": Footer,
    "navshare-el":NavShare

  },
  methods: {
    getProfit(id) {
      var profit = {};

      if (!this.project.Profits) return profits;
      for (var i = 0; i < this.project.Profits.length; i++) {
        if (this.project.Profits[i].ID == id) {
          profit = this.project.Profits[i];
          break;
        }
      }
      return profit;
    },
    getsurplus() {
      if (this.project && this.project.StartTime) {
        var endTime = new Date(this.project.StartTime);
        endTime = endTime.setDate(endTime.getDate() + this.project.Period);
        console.log(this.project.StartTime);
        var total = (endTime - new Date()) / 1000; //秒

        var day = parseInt(total / (24 * 60 * 60)); //计算整数天数
        var afterDay = total - day * 24 * 60 * 60; //取得算出天数后剩余的秒数
        var hour = parseInt(afterDay / (60 * 60)); //计算整数小时数
        var afterHour = total - day * 24 * 60 * 60 - hour * 60 * 60; //取得算出小时数后剩余的秒数
        var min = parseInt(afterHour / 60); //计算整数分
        var afterMin = parseInt(
          total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60
        ); //取得算出分后剩余的秒数

        this.global.surplus.day = day;
        this.global.surplus.hours = hour;
        this.global.surplus.minute = min;
        this.global.surplus.second = afterMin;
      }
    }
  },
  created: function() {

    this.$store.dispatch("project/getProject", this.$route.params.id);
  },
  computed: {
    ...mapState({
      project: state => state.project.project
    }),

    showTeamList() {
      var teamList = [];
      if (this.global.isshowteamall) {
        teamList = this.project.Teams;
      } else {
        for (var i = 0; i < 1; i++) {
          if (!this.project.Teams || this.project.Teams.length == 0) continue;
          teamList.push(this.project.Teams[i]);
        }
      }
      return teamList;
    },
    showTeamWord() {
      if (this.global.isshowteamall) return "收起";
      else return "展示全部";
    },
    sumProfits() {
      var profits = { SupportUser: 0, SupportMoney: 0 };

      if (!this.project.Profits) return profits;
      for (var i = 0; i < this.project.Profits.length; i++) {
        profits.SupportMoney += this.project.Profits[i].SupportMoney;
        profits.SupportUser += this.project.Profits[i].SupportUser;
      }
      return profits;
    }
  }
};
</script>


<style scope>
@import url("../css/detail.css");
</style>
